import { Box } from '@mui/material'
import { Link } from 'react-router'
import googlePlayDownload from '~/assets/images/googlePlayDownload.png'

const GooglePlayButton = (props: { height?: number }) => {
  const height = props.height || 10

  return <Link to='https://play.google.com/store/apps/details?id=com.secretspa.secretspaproapp&hl=en_GB&pli=1' target='_blank' rel='noreferrer'>
    <Box
      component='img'
      src={googlePlayDownload}
      alt='google-play-download'
      sx={{
        height: (theme) => theme.spacing(height),
      }}
    />
  </Link>
}

export default GooglePlayButton
